export default __webpack_public_path__ + "static/media/hamburger.f09dcc2a.svg";